<mbs-card-group>
  <mbs-input-label
    [boldLabel]="true"
    [label]="'storages:addStorageAccountWizard.inputCredentialsStep.authenticationType' | i18next"></mbs-input-label>
  <p class="text-base mb-3">{{ 'storages:addStorageAccountWizard.inputCredentialsStep.labels.serviceAccount' | i18next }}</p>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.serviceAccountEmail"
      [boldLabel]="true"
      [formControl]="serviceAccountEmail"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.serviceAccountEmail' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.serviceAccountEmail' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.files"
      [boldLabel]="true"
      [formControl]="filesControl"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.binaryKey' | i18next"
      [multiple]="false"
      [placeholder]="
        filesControl?.value?.[0]?.name || 'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.binaryKey' | i18next
      "
      [showRequiredMark]="false"
      [trim]="false"
      [type]="'file'">
    </mbs-input>
  </mbs-form-group>
  <mbs-form-group>
    <mbs-input
      [attr.data-e2e]="e2eLocators.projectId"
      [boldLabel]="true"
      [formControl]="projectId"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.projectID' | i18next"
      [placeholder]="'storages:addStorageAccountWizard.inputCredentialsStep.placeholders.projectID' | i18next"
      [showRequiredMark]="false"></mbs-input>
  </mbs-form-group>
</mbs-card-group>
